export default "__VITE_ASSET__Cq83HQpM__"